jQuery(document).ready(function($) {

  /* ------------------------------------------------
    Über uns
  ------------------------------------------------ */

  // add a show more link to every person
  $('.person-text-details').after("<div><a href='#' class='toggle-details'>+ Mehr</a></div>");
  $('.person').addClass('details-hidden');

  // open person details when show more link is clicked
  $('.toggle-details').click(function(e){
    e.preventDefault();

    let person = $(this).closest('.person');

    // show details
    person.toggleClass('show-details');
    person.toggleClass('details-hidden');

    // change link text
    if(person.hasClass('show-details')){
      $(this).text('- Weniger');
    } else{
      $(this).text('+ Mehr');
    }

  });


  /* ------------------------------------------------
    Angebote
  ------------------------------------------------ */

  $(".availability td:contains('frei')").addClass('places-available');
  $(".availability td:contains('besetzt')").addClass('places-taken');


  /* ------------------------------------------------
    Menü to Go
  ------------------------------------------------ */


  // if order values are changed
  $('.menus-grid input').bind("input propertychange", function() {
    const packageName = $(this).parent().parent().data('package-name');
    updatePrice(packageName);
  });

  $('.order-options input').bind("input propertychange", function() {
    const packageName = $(this).parent().parent().data('package-name');
    updatePrice(packageName);
  });


  function updatePrice(packageName){

    // get needed data
    let packageQuantityValue      = $('.' + packageName + '-quantity input').val();
    let packageSinglePriceValue   = $('.' + packageName + '-single-price input').val();
    let packageTotalPrice         = $('.' + packageName + '-total-price input');
    let menusHiddenTotalPrice     = $('#total-price');
    let menusVisibleTotalPrice    = $('.visible-total-price');
    let vegiDiscount              = $('.vegi-discount input');

    // check vegi status
    let orderIsVegi = false;
    $('input[name="order-options[]"]:checked').each(function(){
      if( $(this).val() === 'Vegi' ){ orderIsVegi = true };
    });

    // recalculate single menu price
    packageTotalPrice.val(packageQuantityValue * packageSinglePriceValue);

    // calculate total and discount
    newSubTotal = Number($('.singola-total-price input').val()) + Number($('.amore-total-price input').val()) + Number($('.famiglia-total-price input').val()) + Number($('.squadra-total-price input').val());

    if( orderIsVegi ){
      newVegiDiscount = Math.round(Number(newSubTotal) * 0.1 *20)/20;
    } else{
      newVegiDiscount = 0;
    }

    vegiDiscount.val( newVegiDiscount );
    newTotal = newSubTotal - newVegiDiscount;

    menusVisibleTotalPrice.text( newTotal + " Fr." );
    menusHiddenTotalPrice.val( newTotal + " Fr." );
  }

});
